<div mat-dialog-content>

    <!--=============================================-->
    <!-- Simple Popups - Definition in Dictionary -->
    <!--=============================================-->

    <div *ngIf="!isGenericMode && DictionaryObject as obj">
        <h4>{{obj.Header}}</h4>
        <p [innerHtml]="obj.Body"></p>
    </div>

    <!--=============================================-->
    <!-- Generic Popups - Detail supplied through dialog data -->
    <!--=============================================-->

    <div *ngIf="isGenericMode">
        <h4>{{data.header}}</h4>
        <p [innerHtml]="data.body"></p>
    </div>



    <!--=============================================-->
    <!-- Reusable Templates -->
    <!--=============================================-->

    <ng-template #IsArmContent>
        <!--<div class="alert alert-warning">
            <b>[Arm Content]</b>
            <div>product: {{product}}</div>
            <div>quote: {{quote}}</div>
        </div>-->
        <p *ngIf="isArm && product && quote">
            <!-- DCC uses actual product searches, not opportunities from the API.  Needs quote and product objects... -->
            The {{LgvDataHlpr.LoanTypeFromLgvOpp(opportunity)}} is a variable interest rate with an initial rate of
            {{opportunity?.opportunityInfo?.matchedRate}}% and {{opportunity?.opportunityInfo?.matchedApr}}% APR. A
            {{LgvDataHlpr.LoanTypeFromLgvOpp(opportunity)}} has a margin of {{product?.armMargin}}% and is based
            against a {{product?.armIndex}} as the index. The current index is ({{quote?.armIndexValue}}%). The
            interest rate is fixed for the first {{LgvDataHlpr.ArmFixedTermNumericYears(quote?.armFixedTerm)}} years,
            and then it can adjust up to a maximum of {{quote?.armFirstCap}}% on the initial adjustment, with a
            maximum increase or decrease every
            {{LgvDataHlpr.ArmFixedTermNumericMonths(quote?.armSubsequentChangePeriod)}} months thereafter of
            {{quote?.armPeriodicCap}}% each adjustment.
            <span *ngIf="quote?.armLifetimeCap">Total increase maximum is {{quote?.armLifetimeCap}}%.</span> The floor
            rate after the fixed period = {{product?.armMargin}}%.</p>
        <p *ngIf="isArm && !product && !quote">
            <!-- Opportunities page uses opportunities that have the product info in the opportunity -->
            The {{opportunity?.opportunityType?.name}} is a variable interest rate with an initial rate of
            {{opportunity?.opportunityInfo?.matchedRate}}% and {{opportunity?.opportunityInfo?.matchedApr}}% APR. A
            {{LgvDataHlpr.LoanTypeFromLgvOpp(opportunity)}} has a margin of {{opportunity?.opportunityInfo?.armmargin}}% and is based
            against a {{opportunity?.opportunityInfo?.armindexName}} as the index. The current index is ({{opportunity?.opportunityInfo?.armindexValue}}%). The
            interest rate is fixed for the first {{opportunity?.opportunityInfo?.armfixedTermMonths}} months,
            and then it can adjust up to a maximum of {{opportunity?.opportunityInfo?.armfirstCap}}% on the initial adjustment, with a
            maximum increase or decrease every {{opportunity?.opportunityInfo?.armsubsequentChangePeriod}} months thereafter of
            {{opportunity?.opportunityInfo?.armperiodicCap}}% each adjustment.
            <span *ngIf="opportunity?.opportunityInfo?.armLifetimeCap">Total increase maximum is {{opportunity?.opportunityInfo?.armLifetimeCap}}%.</span> The floor
            rate after the fixed period = {{opportunity?.opportunityInfo?.armmargin}}%.
        </p>

    </ng-template>



    <!--=============================================-->
    <!-- Custom popups that require special HTML -->
    <!--=============================================-->

    <ng-container *ngIf="!isGenericMode && !DictionaryObject">

        <div *ngIf="isMarketValueMode">
            <h4>Market Value Calculation</h4>
            <p>Your home value is based on the purchase price. We then apply our algorithm that adjusts dynamically for
                inflation, and home price appreciation / depreciation in your region.</p>
            <p>Feel free to ask any questions below. If you want to challenge or request the home value just click <a
                    (click)="OnRequestCMA()">Request a Comparative Market Analysis</a> and we will provide you with a
                free of charge comparative market analysis.</p>
        </div>

        <div *ngIf="isEquityCalculation">
            <h4>Equity Calculation</h4>
            <p>Your equity is based on the total market value of your home minus the debt owed. The market value adjusts
                dynamically for inflation, and home price appreciation / depreciation in your region.</p>
            <p>Feel free to ask any questions below. If you want to challenge or request the home value just click <a
                    (click)="OnRequestCMA()">Request a Comparative Market Analysis</a> and we will provide you with a
                free of charge comparative market analysis.</p>
        </div>

        <div *ngIf="isSpeakMortgage">
            <h4>How to “speak mortgage” — a glossary of terms</h4>
            <p><a (click)="onNoClick()" routerLink="/client/glossary">Click here</a> to see our glosary of terms</p>
        </div>

        <div *ngIf="isExpiredProduct">
            <h4>Expired Product</h4>
            <p>The rate and pricing estimate for this product is no longer available as quote was pulled after hours or
                due to expiration of the product. Please contact {{LgvUserSvc.DBUserSS$.value?.company?.name}} for
                current
                rates or more information.</p>
        </div>
        <div *ngIf="isMonthlyPaymentSavings">
            <h4>Monthly Payment Savings</h4>
            <p>Estimated savings is based on a payment example for a {{LgvDataHlpr.LoanTypeFromLgvOpp(opportunity)}}
                mortgage amortized over {{opportunity?.opportunityInfo?.loanTermMonths}} months.</p>
            <ng-container *ngIf="isArm then IsArmContent"></ng-container>
            <p>Loan options are measured against your current mortgage and additional high-interest payments that have
                been factored into monthly payments through this calculator.</p>

        </div>
        <div *ngIf="isMonthlyPaymentIncrease">
            <h4>Monthly Payment Increase</h4>
            <p>Estimated monthly payment increase is based on a payment example for a
                {{LgvDataHlpr.LoanTypeFromLgvOpp(opportunity)}} mortgage amortized over
                {{opportunity?.opportunityInfo?.loanTermMonths}} months.</p>
            <ng-container *ngIf="isArm then IsArmContent"></ng-container>
            <p>Loan options are measured against your current mortgage and additional high-interest payments that have
                been factored into monthly payments through this calculator.</p>
        </div>

        <div *ngIf="isRateAndAPR">
            <h4>Interest Rate & APR</h4>
            <p>Interest rate of {{opportunity?.opportunityInfo?.matchedRate}}% (APR
                {{opportunity?.opportunityInfo?.matchedApr}}%) for a {{LgvDataHlpr.LoanTypeFromLgvOpp(opportunity)}}
                mortgage amortized over {{opportunity?.opportunityInfo?.loanTermMonths}} months is current as of
                {{opportunity?.opportunityInfo?.createdTimeStamp | date: 'MM/dd/yy'}}.</p>
            <ng-container *ngIf="isArm then IsArmContent"></ng-container>
            <p>The Interest Rate is the amount charged for borrowing money, usually expressed as a percentage of the
                loan amount. Annual Percentage Rate (APR) is a finance charge expressed as an annual rate. It represents
                the interest plus fees and any other applicable one-time costs associated with your loan, including
                mortgage insurance, discount points, origination fees, and certain closing costs.</p>
        </div>
        <div *ngIf="isPoints">
            <ng-container *ngIf="opportunity?.opportunityInfo?.pointsCost >= 0 then PointsCost else PointsCredit"></ng-container>
            <ng-template #PointsCost>
                <h4>Points (Cost)</h4>
                <p>This opportunity has {{opportunity?.opportunityInfo?.points | number : '1.3-3' | null}} points, adding ${{opportunity?.opportunityInfo?.pointsCost | number : '1.0-0' | null}} to the estimated upfront cost of the loan.</p>
                <p>Points are paid directly to the lender to lower your interest rate when you purchase a home. A point is equal to 1 percent of the loan amount. By paying more in points, you can potentially reduce your monthly mortgage payments and save money in interest over the life of the loan.</p>
            </ng-template>
            <ng-template #PointsCredit>
                <h4>Points (Credit)</h4>
                <p>This opportunity has {{opportunity?.opportunityInfo?.points | number : '1.3-3' | null}} points, reducing ${{abs(opportunity?.opportunityInfo?.pointsCost) | number : '1.0-0' | null}} from the estimated upfront cost of the loan.</p>
                <p>Points are paid directly to the lender to lower your interest rate when you purchase a home. A point is equal to 1 percent of the loan amount. Negative points are closing cost rebates to qualified borrowers or mortgage brokers that can reduce the upfront closing costs.</p>
            </ng-template>
        </div>
        <div *ngIf="isEstimatedCosts">
            <h4>Estimated Loan Costs</h4>

            <p>The estimated loan costs for each loan include the cost of the loan (points), if applicable, as well as closing costs. Closing costs may include, but are not limited to underwriting, processing, and loan origination fees.</p>

            <div *ngIf="opportunity?.opportunityInfo?.feeDetails.length > 0">
                <div><b>{{opportunity?.opportunityType?.name}}</b></div>
                <table>
                    <tr *ngFor="let fee of opportunity?.opportunityInfo?.feeDetails">
                        <td>{{fee.description}}</td>
                        <td style="text-align:right;">${{fee.amount | number : '1.0-0' | null}}</td>
                    </tr>
                    <tr style="border-top:1px solid">
                        <td><b>Total Est. Fees</b></td>
                        <td style="text-align:right">${{opportunity?.opportunityInfo?.closingCost | number : '1.0-0' | null}}</td>
                    </tr>
                </table>
            </div>

        </div>
        <div *ngIf="isTodaysRate">
            <h4>Today's Rate</h4>
            <p>Rate is current as of {{todaysDate | date: 'mediumDate'}}. Qualifications are based on a 760 minimum FICO credit score, 80% assumed loan-to-value for a first lien mortgage on a single-family home, primary residence. Interest rates and APR are for informational purposes only. Rates, terms, and conditions are subject to change without prior notice and may vary based on creditworthiness, qualifications, and collateral conditions. This is not a guarantee to lend. If loan does not close for any reason, out-of-pocket costs incurred by the consumer will not be refunded.</p>
        </div>
        <div *ngIf="isQuoteDetails">
            <ng-container *ngIf="quoteDetail as q">
                <h4><span *ngIf="product">
                    <span *ngIf="!(authMgr.IsClient$ | async)">{{product?.programName}}</span>
                    <span *ngIf="(authMgr.IsClient$ | async)">{{q?.opportunityType?.name}}</span>
                    - </span>{{q?.rate ? q?.rate : q?.matchedRate | number : '1.3-3'}}%</h4>
                <div>
                    <div *ngIf="product && !(authMgr.IsClient$ | async)" style="color:#848484;">{{product?.investor}}</div>
                    <div class="Vert-15"></div>
                    <div style="font-size: 20px;">Loan Details</div>
                    <div class="Vert-10"></div>
                    <table class="loan-details">
                        <tr><td>Rate | APR</td><td>{{q?.rate ? q?.rate : q?.matchedRate | number : '1.3-3'}}% | {{q?.apr ? q?.apr : q?.matchedApr | number : '1.3-3'}}%</td></tr>
                        <tr><td>Points | Price</td> <td [ngClass]="(q?.price ? q?.price : q?.matchedPrice) < 100 ? 'red-font' : 'green-font'">{{(100 - q?.price ? q?.price : q?.matchedPrice) | number : '1.3-3'}} | {{q?.price ? q?.price : q?.matchedPrice | number : '1.3-3'}}%</td></tr>
                        <tr><td>Points Cost</td><td [ngClass]="q.price < 100 ? 'red-font' : 'green-font'">{{ q.pointsCost | currency : 'USD' : 'symbol' : '1.0'}} </td></tr>
                        <tr><td>Monthly P&I</td> <td>${{q.principalAndInterest | number : '1.0-0'}}</td></tr>
                        <tr><td>Mortgage Insurance</td> <td>${{q.monthlyMi | number : '1.0-0'}}</td></tr>
                        <tr><td>Lock Period (Days)</td> <td>{{q.lockPeriod}}</td></tr>
                        <tr *ngIf="data.loanAmount"><td>Loan Amount</td> <td>${{data.loanAmount | number : '1.0-0'}}</td></tr>
                    </table>

                    <div class="Vert-20"></div>
                    <div style="font-size: 20px;">Fees & Costs</div>
                    <div class="Vert-10"></div>
                    <table class="fee-table">
                        <tr><td>Points Cost</td><td [ngClass]="q.price < 100 ? 'red-font' : 'green-font'">{{ q.pointsCost  | currency : 'USD' : 'symbol' : '1.0'}} </td></tr>
                        <ng-container *ngFor="let fee of buyerFees(q?.lenderFeeDetails)">
                            <tr><td>{{fee.feeDescription}}</td> <td>${{fee.feeTotalCalculatedAmount | number : '1.0-0'}}</td></tr>
                        </ng-container>
                        <tr><td colspan="2"><hr /></td></tr>
                        <tr><td><b>Est. Due at Closing</b></td> <td><b>{{ calcEstTotalDue(q) | currency : 'USD' : 'symbol' : '1.0'}}</b></td></tr>
                    </table>
                </div>
            </ng-container>
        </div>

    </ng-container>
</div>

<mat-dialog-actions class="mb-1 float-end">
    <button mat-button class="btn btn-primary" (click)="onNoClick()">Close</button>
</mat-dialog-actions>
